import React, { useState } from "react";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/Redirecting Styles/FooterStyle/DigitalMarketing.css";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";
import { Helmet } from "react-helmet";
import section1 from "../../../assets/canada/Digital-marketing/dm-sec-1-1.jpg";
import section2 from "../../../assets/canada/Digital-marketing/dm-sec-1-2.jpg";
import section3 from "../../../assets/canada/Digital-marketing/dm-sec-1-3.jpg";

const CanadaDigitalMarketing = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
        Best Digital Marketing Company in USA | Zithas Technologies
        </title>
        <meta
          name="description"
          content="Elevate Your Brand with one of the best digital Marketing Companies in USA. Get expert Online Marketing Services from top digital marketing firms in USA."
        />
        <meta
          name="keywords"
          content="digital marketing USA, digital marketing company in USA, digital marketing services USA, best digital marketing company in USA, best digital marketing companies in USA, digital marketing firms in USA, top digital marketing services USA, online marketing USA, digital marketing services"
        />
      </Helmet>
      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg2 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title" style={{ fontSize: "50px" }}>
                  Explore Digital Marketing Services
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Broaden Your Horizon and Elevate Sales Through Digital
                      Marketing to Connect with a Wider Audience!
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First section */}
      <section className="bd-choose-area fix pb-70 pt-80 ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text z-index">
                  <h2
                    className="bd-section-title mb-15"
                    style={{ fontSize: "46px" }}
                  >
                    Supercharge your business with this winning approach!
                  </h2>
                  <div className="bd-section-title-wrapper"></div>
                  <p
                    className="mb-20"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
                    With digital marketing, businesses in USA can efficiently
                    and quickly expand their reach to a wider audience.
                    Leveraging the capabilities of social media platforms like
                    Facebook, Twitter, and LinkedIn, you can engage with a
                    diverse customer base. Online marketing further empowers to
                    introduce new offerings to potential customers who might not
                    have previously encountered your business.
                  </p>
                  <p className="" style={{ fontSize: "18px" }}>
                    When it comes to online customer engagement, digital
                    marketing takes the lead, overshadowing traditional
                    approaches. To cultivate substantial connections with both
                    potential and current customers, businesses in USA must
                    entrust a professional digital marketing company that offers
                    content compelling, visually striking designs, and valuable
                    insights.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end  z-index">
                  <div className="row align-items-center media-respon-digital custom-mar-15">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          src={section1}
                          className="resp-img bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section2}
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section3}
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                  {/* <div className="bd-choose-video-popup">
                                    <a className="play_btn popup-video popup-youtube" onClick={()=> setOpen(true)}>
                                      <i className="fas fa-play"></i></a>
                                      <ModalVideo autoplay isOpen={isOpen} channel='youtube' videoId='L61p2uyiMSo' onClose={() => setOpen(false)}/>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="bd-choose-video-popup first_pop_video"> */}
        <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="L61p2uyiMSo"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          style={{ display: "none" }}
          className="btn btn  first_pop_video responsive_digital"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button>

        {/* </div> */}
      </section>

      <section className="bd-service-area pb-80 ">
        <div className="container">
          <div className="row">
                <h2 className="pt-2 pb-2" style={{ fontSize: "46px" }}>
                  {" "}
                  <span style={{ color: "#ffbf1e" }}>Services</span> We Offer
                </h2>
            <div className="col-lg-4 col-md-6 pt-20">
              <div className="bd-section-title-wrapper mb-50">
                <h2 className="bd-section-title" style={{ fontSize: "46px" }}>
                  Boost Your Business Efficiency with{" "}
                  <span style={{ color: "#ffbf1e" }}> Digital Marketing </span>{" "}
                  services.
                </h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440353/website/icons/seo-64_syyuz1.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Search Engine Optimization (SEO)</a>
                </h4>
                <p>
                  Supercharge Your Brand's Visibility through Effective SEO
                  Strategies, Driving a Growth in Organic Traffic.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440353/website/icons/pay-per-click-64_o03lrg.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Pay-per-Click (PPC)</a>
                </h4>
                <p>
                  Achieving a Top Ranking Quickly and Efficiently Depends on the
                  Number of Clicks Your Link Receives.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440354/website/icons/social-media-marketing-64_yu13tb.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Social Media Marketing</a>
                </h4>
                <p>
                  Connect with Your Desired Customer Segments Using
                  Facebook/Instagram Ads Customized for Specific Demographics.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440353/website/icons/content-marketing-64_mu03q4.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Content Marketing</a>
                </h4>
                <p>
                  Engage Your Audience, Attend to Their Questions, and
                  Capitalize on the Potential for Lead Generation and Sales
                  Conversion.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440353/website/icons/marketing-64_iuhj64.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Marketing Analytics</a>
                </h4>
                <p>
                  Enhance Your ROI with Ease by Gaining Valuable Insights into
                  Consumer Behavior.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for a Digital Marketing Firm in USA?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Digital Marketing Solutions, Let's kick start now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (307) 683-8009"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (307) 683-8009
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaDigitalMarketing;
